import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { offer, packageIncludes, trustItems } from '../data/offer';
export function Pricing() {
  return <section id="pricing" aria-labelledby="pricing-title" className="scroll-mt-14 bg-navy text-white" data-id="element-195" data-mp="2oi7h1kvblszl">
      <div className="mx-auto max-w-5xl px-5 py-16 sm:py-20" style={{
      paddingTop: "22px",
      paddingBottom: "33px"
    }} data-id="element-196" data-mp="2jk5xkytzfrnl">
        <div className="text-center" data-id="element-197" data-mp="1vw4jlae1bj0s">
          <p className="text-sm font-semibold text-cyan" data-id="element-198" data-mp="1rsye44yqxvvd">One system. 100 prompts. 5 bonuses.</p>
          <h2 id="pricing-title" className="mt-3 font-display text-3xl font-black sm:text-4xl" data-id="element-199" data-mp="25sr2vuqpq20p">
            Get the complete Realtor AI system
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-[15px] leading-relaxed text-white/70" data-id="element-200" data-mp="20v7pex1u9t9t">
            Ideal for {offer.idealFor.join(' · ')} who want a more structured way to incorporate AI into everyday real estate work.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-12 grid overflow-hidden rounded-3xl border border-white/10 bg-ocean md:grid-cols-[1fr_1.1fr]" data-id="element-201" data-mp="3w08dq71f7k9u">
          <div className="flex flex-col items-center justify-center border-b border-white/10 px-6 py-10 text-center md:border-b-0 md:border-r" style={{
          paddingTop: "10px",
          paddingBottom: "13px"
        }} data-id="element-202" data-mp="eqk2zf7ia2rx">
            <p className="font-display text-lg font-black" data-id="element-203" data-mp="3i5xxke3hoyfe">THE REALTOR AI PLAYBOOK™</p>
            <p className="mt-6 text-sm text-white/60" data-id="element-204" data-mp="3n5u1kdc6spuy">
              Regular value <span className="text-white/50 line-through" data-id="element-205" data-mp="3rywucj953va3">{offer.was}</span>
            </p>
            <p className="mt-3 text-xs font-bold uppercase tracking-[0.2em] text-white/70" data-id="element-206" data-mp="2uj96b1slbtm4">Today</p>
            <p className="mt-1 font-display font-black leading-none text-gold" data-id="element-207" data-mp="2zgivcgc2i39f">
              <span className="align-top text-4xl" style={{
              fontFamily: "'DM Sans', sans-serif"
            }} data-id="element-208" data-mp="2rgcv1t0ym9u7">$</span>
              <span className="text-[88px]" style={{
              fontFamily: "'DM Sans', sans-serif"
            }} data-id="element-209" data-mp="2mgqfhcxnshi8">{offer.now}</span>
            </p>
            <p className="mt-3 text-sm font-semibold text-white/85" data-id="element-210" data-mp="318in12r7or9e">One-time payment · Lifetime Access</p>
            <p className="mt-1 text-xs text-white/50" data-id="element-211" data-mp="2w9xnl5jsabm0">Payment will be processed in your local currency</p>
            <p className="mt-5 rounded-full border border-gold/40 px-4 py-1.5 text-xs font-bold text-gold" data-id="element-212" data-mp="23ixh8nxzcvr6">
              You save {offer.saved} · 50% OFF · Limited Launch Price
            </p>
            <div className="mt-7 flex w-full justify-center" data-id="element-213" data-mp="2dh3g0wohplrt">
              <CTAButton size="md" data-id="element-214" data-mp="2dfimnadww8vj">Get the Realtor AI Playbook™ now</CTAButton>
            </div>
            <ul className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-white/60" data-id="element-215" data-mp="3tts8nxuollj7">
              {trustItems.map(({
              icon: Icon,
              label
            }) => <li key={label} className="inline-flex items-center gap-1.5" data-id="element-216" data-mp="a42dnwg2onc">
                  <Icon className="h-3.5 w-3.5 text-cyan" aria-hidden="true" data-id="element-217" data-mp="5971ystno2nx" />
                  {label}
                </li>)}
            </ul>
          </div>

          <div className="px-6 py-10 sm:px-10" data-id="element-218" data-mp="3ngwd28qv6m4g">
            <p className="text-sm font-semibold text-white/70" data-id="element-219" data-mp="3rg595k9dmw36">Your complete package includes:</p>
            <ul className="mt-5 space-y-3" data-id="element-220" data-mp="j0d6j3bskqho">
              {packageIncludes.map(f => <li key={f} className="flex items-start gap-3 text-[15px] text-white/90" data-id="element-221" data-mp="j37rqx2mqfc5">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-success" strokeWidth={3} aria-hidden="true" data-id="element-222" data-mp="o22lgu24xob1" />
                  {f}
                </li>)}
            </ul>
          </div>
        </motion.div>
      </div>
    </section>;
}